import React, { useEffect, useState } from "react";
import { UserInputField } from "./UserCreaterFormStyled";
import Select from "react-select";
import { ThemeButton } from "@sc/custom.styled";
import { UserDetailsContainer,UserListLoadingContainer } from "@c/users-view/MainContent.styled";
import { AutoContainer } from "@sc/custom.styled";
import { module as user } from "@st/user";
import { module as inviteCode } from "@st/inviteCode";
import { connectStore } from "redux-box";
import { module as onboard } from "@st/onboard";
import { module as activity } from "@st/activity";
import useDebouncing from "../../../../utils/useDebouncing";
import swal from "sweetalert2";
import userApi from "@s/api/user";
import "../users.css";
import { LoaderImage } from "../../../../static/styled/custom.styled";

const UserCreaterForm = (props) => {
  const userTypes = [
    {
      label:'Student',
      value: null
    },
    {
      label:'Teacher',
      value: true
    },
    {
      label:'Staff/Other Subject Teachers',
      value: false
    },
  ]
  const [state, setState] = useState({
    userInfo: {
      name: "",
      email: "",
      // contact_no: "",
      password: "",
      grade: "",
      schoolCode:'',
      school: "",
      section: "",
      is_teacher: false,
      academicYear:"",
      cms_id: ""
    },
  });

  const [allGrades, setAllGrades] = useState([]);
  const [allSections, setAllSections] = useState([]);
  const [showPassword, setShowPassword] = useState(false);

  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      position: "absolute",
    }),
    control: (provide) => ({
      ...provide,
      width: "95%",
      margin: "0 auto",
      border: "none",
      boxShadow: "none",
    }),
  };

  const debouncedSchoolCode = useDebouncing(state.userInfo.schoolCode, 1000);

  useEffect(() => {
    console.log(props.activity);
    if (props.activity.gradeList.length > 0) {
      setAllGrades(props.activity.gradeList);
    }
  }, [props.activity.gradeList]);

  useEffect(()=>{
    if(props.onboard && props.onboard.user && props.onboard.user.school && props.inviteCode.adminSchoolList){
        let school = props.inviteCode.adminSchoolList.find((school)=>school.id===props.onboard.user.school)

        if(school){
          setState({
            userInfo:{...state.userInfo,school:school,schoolCode:school.school_code}
          })
        }
    }
  },[props.onboard.user,props.inviteCode.adminSchoolList])

  useEffect(() => {
    if (props.user.sectionsList && props.user.sectionsList.length > 0) {
      setAllSections(props.user.sectionsList);
    }
  }, [props.user.sectionsList]);

  useEffect(() => {
    if (debouncedSchoolCode && debouncedSchoolCode.length == 6) {
      props.user.validateSchool(debouncedSchoolCode);
      setState({
        userInfo: {
          ...state.userInfo,
          grade: "",
          section: "",
        },
      });
    }
  }, [debouncedSchoolCode]);

  useEffect(() => {
    if (props.user.user_created) {
      setState({
        userInfo: {
          name: "",
          email: "",
          // contact_no: "",
          password: "",
          grade: "",
          schoolCode: "",
          school: "",
          section: "",
          academicYear:"",
          is_teacher: false,
          cms_id: "",
        },
      });
      setAllSections([]);
    }
  }, [props.user.user_created]);

  const handleUserInfo = (type, evt, length) => {
    if (evt.target.value.length <= length) {
      setState({
        userInfo: { ...state.userInfo, [type]: evt.target.value },
      });
    }
  };

  const changeGrade = (selectedGrade) => {
    setState({
      userInfo: { ...state.userInfo, grade: selectedGrade, section: "" },
    });
    setAllSections([]);

    if (props.user.school) {
      let payload = {
        school: props.user.school.id,
        grade: selectedGrade.id,
      };
      props.user.getSections(payload);
    }
  };

  const validate = (name) => {
    let n = name.trim();
    const re = /^[a-zA-Z0-9_ .]*$/;
    if (re.test(n) == true && name.length > 2) return true;
    return false;
  };

  const validateEmail = (email) => {
    // const re =
    //   // eslint-disable-next-line no-useless-escape
    //   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-z\-0-9]+\.)+[a-z]{2,}))$/;
    const re =
      // eslint-disable-next-line no-useless-escape
      /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;

    return re.test(email);
  };

  const validatePassword = (password) => {
    const re = /^[0-9]+$/;
    if (re.test(password) == true && password.length == 6) return true;
    return false;
  };

  const handleSubmitBtn = async () => {
    if (props.user && props.user.loading) return;
    const userInfo = state.userInfo;
    const validateName = validate(userInfo.name);
    if (!validateName) {
      swal("Error!", "Please enter a valid name!", "error");
      return;
    }
    if (!validateEmail(userInfo.email)) {
      swal("Error!", "Please enter a valid email!", "error");
      return;
    }
    // if (userInfo.contact_no.length < 6 && userInfo.contact_no.length > 15) {
    //   swal("Error!", "Please enter a valid phone number!", "error");
    //   return;
    // }
    if (!validatePassword(userInfo.password)) {
      swal("Error!", "Please enter a valid password!", "error");
      return;
    }
    if (!userInfo.grade && !userInfo.grade.id) {
      swal("Error!", "Please enter a valid grade!", "error");
      return;
    }

    if (!userInfo.section) {
      swal("Error!", "Please enter a valid section!", "error");
      return;
    }
    if (!userInfo.academicYear) {
      swal("Error!", "Please enter a valid academic year!", "error");
      return;
    }
    if (state.userInfo.is_teacher && state.userInfo.is_teacher.value === null) {
      if (!userInfo.cms_id) {
        swal("Error!", "CMS ID is required for students!", "error");
        return;
      } else if (!/^\d{1,11}$/.test(userInfo.cms_id.trim())) {
        swal("Error!", "CMS ID must be up to 11 numeric digits!", "error");
        return;
      }
    }
    const payload = {
      ...state.userInfo,
      grade: state.userInfo.grade.id,
      section: state.userInfo.section.value,
      school: props.user.school.id,
      is_teacher: state.userInfo.is_teacher.value,
      device_type: "web",
      academic_year: state.userInfo.academicYear.value,
      cms_id: userInfo.cms_id || null,
    };

    props.user.registerUser(payload);
  };

  return (
    // <div className='add_user_form_container'>
    <UserDetailsContainer>
      {props.user && props.user.loading ? (
        <UserListLoadingContainer>
          <img
            alt="loading"
            width="40"
            height="40"
            src={require("static/img/Theme-loader.gif")}
          />
        </UserListLoadingContainer>
      ) : (
        <AutoContainer>
          <div className="add_user_form_main">
            <div className="add_user_form_body">
              <UserInputField
                type="text"
                placeholder="Name of the User"
                border={"2px solid #004ea3"}
                radius={"10px"}
                fontSize={"14px"}
                margin={"3px"}
                value={state.userInfo.name}
                onChange={(evt) => handleUserInfo("name", evt, 100)}
              />
              <UserInputField
                type="email"
                placeholder="School Email of the User"
                border={"2px solid #004ea3"}
                radius={"10px"}
                fontSize={"14px"}
                margin={"3px"}
                value={state.userInfo.email}
                onChange={(evt) => handleUserInfo("email", evt, 254)}
              />
              <div style={{ position: "relative" }}>
                <UserInputField
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter Password in DDMMYY format "
                  border={"2px solid #004ea3"}
                  radius={"10px"}
                  fontSize={"14px"}
                  margin={"3px"}
                  value={state.userInfo.password}
                  style={{ position: "relative" }}
                  onChange={(evt) => handleUserInfo("password", evt, 6)}
                />
                {showPassword ? (
                  <i
                    className="fa fa-eye-slash show_password"
                    onClick={() => setShowPassword(false)}
                  />
                ) : (
                  <i
                    className="fa fa-eye show_password"
                    onClick={() => setShowPassword(true)}
                  />
                )}
              </div>
              {/* <UserInputField
                type="text"
                placeholder="Contact Number of the User"
                border={"2px solid #004ea3"}
                radius={"10px"}
                fontSize={"14px"}
                margin={"3px"}
                value={state.userInfo.contact_no}
                onChange={(evt) => handleUserInfo("contact_no", evt, 15)}
              /> */}
              <UserInputField
                type="text"
                disabled={
                  props.onboard &&
                  props.onboard.user &&
                  props.onboard.user.school
                }
                placeholder="Enter School Code"
                border={"2px solid #004ea3"}
                radius={"10px"}
                fontSize={"14px"}
                margin={"3px"}
                value={state.userInfo.schoolCode}
                onChange={(evt) => handleUserInfo("schoolCode", evt, 6)}
              />
              {props.user.school && (
                <UserInputField
                  type="text"
                  disabled={true}
                  border={"2px solid #004ea3"}
                  radius={"10px"}
                  fontSize={"14px"}
                  margin={"3px"}
                  value={props.user.school && props.user.school.name}
                />
              )}
              <Select
                className="dropdown-container"
                value={state.userInfo.grade}
                onChange={changeGrade}
                options={allGrades && allGrades.length >= 1 && allGrades}
                placeholder="Select Grade"
                // styles={{ border: "2px solid #004ea3" }}
                styles={customStyles}
                menuPlacement="auto" // auto, top, or bottom
                menuPosition="fixed"
                // menuIsOpen={allGrades && allGrades.length >= 1 && true}
              />
              <Select
                className="dropdown-container"
                value={state.userInfo.section}
                onChange={(selectedSection) =>
                  setState({
                    userInfo: { ...state.userInfo, section: selectedSection },
                  })
                }
                options={allSections && allSections}
                placeholder="Select Section"
                styles={customStyles}
                menuPlacement="auto" // auto, top, or bottom
                menuPosition="fixed"
              />
              <Select
                className="dropdown-container"
                value={state.userInfo.is_teacher}
                onChange={(userType) =>
                  setState({
                    userInfo: { ...state.userInfo, is_teacher: userType },
                  })
                }
                options={userTypes}
                placeholder="Select User Type"
                styles={customStyles}
                menuPlacement="auto" // auto, top, or bottom
                menuPosition="fixed"
              />
              {state.userInfo.is_teacher && state.userInfo.is_teacher.value === null && (
                <UserInputField
                  type="text"
                  placeholder="CMS ID (11 numeric digits)"
                  border={"2px solid #004ea3"}
                  radius={"10px"}
                  fontSize={"14px"}
                  margin={"3px"}
                  value={state.userInfo.cms_id}
                  onChange={(evt) => handleUserInfo("cms_id", evt, 11)}
                />
              )}
              <Select
                className="dropdown-container"
                value={state.userInfo.academicYear}
                onChange={(selectedYear) =>
                  setState({
                    userInfo: { ...state.userInfo, academicYear: selectedYear },
                  })
                }
                options={
                  props.user.academicYears &&
                  props.user.academicYears.length > 0 &&
                  props.user.academicYears.map((year) => ({
                    label: year.academic_year,
                    value: year.id,
                  }))
                }
                placeholder="Select Academic Year"
                styles={customStyles}
              />
              <div
                style={{
                  minHeight: 100,
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <ThemeButton
                  onClick={() => handleSubmitBtn()}
                  disabled={props.user && props.user.loading}
                  primary
                  type="button"
                  style={{ width: "75%", margin: "0 auto", opacity: props.user && props.user.loading ? 0.6 : 1 }}
                >
                  {props.user && props.user.loading ? "Creating User..." : "Create User"}
                </ThemeButton>
              </div>
            </div>
          </div>
        </AutoContainer>
      )}
    </UserDetailsContainer>

    // </div>
  );
};

export default connectStore({
  user,
  onboard,
  activity,
  inviteCode
})(UserCreaterForm);
